import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@metarouter-private/mr-mui';

import { PIPELINE_STATUSES } from '@ion/api';

const ERROR_MESAGE =
  "Error determining pipeline's status. If this continues, please contact your Customer Success Manager for assistance.";
const UNKNOWN_MESSAGE =
  "Unable to determine the pipeline's status. If this continues, please contact your Customer Success Manager for assistance.";

const TOOLTIP_PROPS = {
  arrow: true,
  placement: 'top',
};

export default function PipelineErrorTooltip({ status, children }) {
  if (status === PIPELINE_STATUSES.Error) {
    return (
      <Tooltip {...TOOLTIP_PROPS} title={ERROR_MESAGE}>
        {children}
      </Tooltip>
    );
  }

  if (status === PIPELINE_STATUSES.Unknown) {
    return (
      <Tooltip {...TOOLTIP_PROPS} title={UNKNOWN_MESSAGE}>
        {children}
      </Tooltip>
    );
  }

  return children;
}

PipelineErrorTooltip.propTypes = {
  status: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
